import { Container, Row, Col, Card } from "react-bootstrap";

const ReviewsData = [
  {
    name: 'Mohammed . A',
    reviewText: 'محترم وراقي بالتعامل',
    source: 'https://mostaql.com/u/raouf_layadi/reviews/7972187'
  },
  {
    name: 'Ahmed',
    reviewText: 'شخص جدا محترم ومتعاون .. وسريع في عمله انصح الجميع التعامل معه بدون اي تردد .. تحياتي لك اخي Abderaouf',
    source: 'https://mostaql.com/u/raouf_layadi/reviews/8205888'
  },
  {
    name: 'Mohammed . A',
    reviewText: 'مبرمج محترم ومتفوق جدا في عمله تقبل مني كل التعديلات بصدر رحب انصح جدا بالتعامل معه ولن يكون اخر مشروعاتي معه',
    source: 'https://mostaql.com/u/raouf_layadi/reviews/7845269'
  },

];

export const Reviews = () => {
  return (
    <section  className="reviews mt-4 p-4 my-8 mb-4" id="reviews">
      <Container>
        <Row>
          <Col size={12} className="text-center">
            <h1>Reviews</h1>
            <p>What clients have said about my work.</p>
          </Col>
        </Row>
        <Row>
          {ReviewsData.map((review, idx) => (
            <Col style={{marginTop:"50px"}} key={idx} size={12} sm={6} md={4}>
              <Card
                className="mb-24 h-100 rounded-lg"
                style={{
                  background: 'linear-gradient(90.21deg, #AA367C -5.91%, #4A2FBD 111.58%)',
                  border: '1px solid rgba(255,255,255,0.15)',
                  color: '#fff',
                  
                }}
              >
                <Card.Body>
                  <Card.Title>{review.name}</Card.Title>
                  <Card.Text style={{fontSize:"20px"}}>{review.reviewText}</Card.Text>
                </Card.Body>
                {review.source && (
                  <Card.Footer style={{
                    background: 'transparent',
                    borderTop: '1px solid rgba(255,255,255,0.15)'
                  }}>
                    <a
                      href={review.source}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-light rounded-full btn-sm"
                    >
                      View Source
                    </a>
                  </Card.Footer>
                )}
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}